export const supportedCountry = {
  ae: {
    countryCode: '+971',
    currency: 'AED',
    timeZones: [{ name: 'Asia/Dubai', time: +240 }],
  },
  in: {
    countryCode: '+91',
    currency: '&#8377',
    timeZones: [{ name: 'Asia/Kolkata', time: +330 }],
  },
  qa: {
    countryCode: '+974',
    currency: 'QAR',
    timeZones: [{ name: 'Asia/Qatar', time: +180 }],
  },
  sa: {
    countryCode: '+966',
    currency: 'SAR',
    timeZones: [{ name: 'Asia/Riyadh', time: +180 }],
  },
  bh: {
    countryCode: '+973',
    currency: 'BHD',
    timeZones: [{ name: 'Asia/Bahrain', time: +180 }],
  },
  kw: {
    countryCode: '+965',
    currency: 'KWD',
    timeZones: [{ name: 'Asia/Kuwait', time: +180 }],
  },
  om: {
    countryCode: '+968',
    currency: 'OMR',
    timeZones: [{ name: 'Asia/Dubai', time: +240 }],
  },
};

export const DEFAULT_COUNTRY_LOCATION = {
  country: '',
  timeOffset: null,
};

export const COUNTRY_LOCATION = 'COUNTRY_LOCATION';

export type SupportedCountryType = keyof typeof supportedCountry;

export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const FROM_APP_COHORT_ID = 'from_app_cohortId';
export const COUNTRY_CODE = 'countryCode';
export const LAST_SELECTED_BATCH = 'last_selected_batch';
export const LAST_SELECTED_BATCH_SUBJECT = 'last_selected_batch_subject';
export const LAST_SELECTED_COHORT_PRE_LOGIN = 'last_selected_cohort_pre_login';
export const LAST_SELECTED_COHORT_POST_LOGIN = 'last_selected_cohort_post_login';

/** Stage cohort IDs (staging only) */
export const STAGING_SCHOOL_CURRICULUM_COHORT_ID = '65c4f17c4853114a8c295b38';
export const STAGING_ENGLISH_COHORT_ID = '66e134a8d29278d658c82d03';
export const STAGING_MATHS_COHORT_ID = '66f2e42e8d2e77a867cef01f';

/** Production cohort IDs (used by pre-prod + prod) */
export const PROD_SCHOOL_CURRICULUM_COHORT_ID = '65e99476c863730018401036';
export const PROD_ENGLISH_COHORT_ID = '66fc2b33a65357d9a307eefb';
export const PROD_MATHS_COHORT_ID = '66fc2a398b612402e9561576';

const isStagingEnv = process.env.NEXT_PUBLIC_ENV === 'staging';

/** Env-resolved cohort IDs: staging → stage; pre-prod + prod → prod */
export const SCHOOL_CURRICULUM_COHORT_ID = isStagingEnv
  ? STAGING_SCHOOL_CURRICULUM_COHORT_ID
  : PROD_SCHOOL_CURRICULUM_COHORT_ID;
export const ENGLISH_COHORT_ID = isStagingEnv
  ? STAGING_ENGLISH_COHORT_ID
  : PROD_ENGLISH_COHORT_ID;
export const MATHS_COHORT_ID = isStagingEnv
  ? STAGING_MATHS_COHORT_ID
  : PROD_MATHS_COHORT_ID;

export const REFERRAL_ERROR_MESSAGE = {
  REFERAL_MAPPING_EXISTS: 'BTM: Referral mapping already exists',
  APPLICABLE_FOR_NEW_USER: 'Refer & earn is applicable only for new user',
};

export const weekDays = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

export const SCHEDULE_INSIDE_DATA = 'SCHEDULE_INSIDE_DATA';

export const EXPLORE_REFETCH_AFTER_PURCHASE = 'explore_refetch_after_purchase';
export const OPEN_SESSION_DEEPLINK_KEY = 'openSessionDeeplinkRedirect';
